import AffectationStatusBadge from '@/components/Affectations/AffectationStatusBadge';
import type { Affectation } from '@/models/types';
import { DATE_TIME_FORMAT } from '@/shared/utils/date-utils';
import type { useTranslate } from '@tolgee/react';
import dayjs from 'dayjs';
import isObject from 'lodash/isObject';
import type { DataTableColumn } from 'mantine-datatable';

type Translate = ReturnType<typeof useTranslate>['t'];

type AffectationColumnsOptions = {
  /** Ajoute la date de dernière modification (ex. date de validation ou de refus). */
  withDateUpdated?: boolean;
};

const formatDate = (date: string | null | undefined): string =>
  date ? dayjs(date).format(DATE_TIME_FORMAT) : '-';

/** Colonnes communes d'une table d'affectations : date(s), rôle, établissement, statut. */
export const getAffectationColumns = (
  t: Translate,
  { withDateUpdated = false }: AffectationColumnsOptions = {},
): DataTableColumn<Affectation>[] => [
  {
    accessor: 'date_created',
    title: t('profil.affectations.columns.date_created'),
    textAlign: 'center',
    render: ({ date_created }) => formatDate(date_created),
  },
  ...(withDateUpdated
    ? [
        {
          accessor: 'date_updated',
          title: t('profil.affectations.columns.date_updated'),
          textAlign: 'center',
          render: ({ date_updated }) => formatDate(date_updated),
        } satisfies DataTableColumn<Affectation>,
      ]
    : []),
  {
    accessor: 'role',
    title: t('profil.affectations.columns.role'),
    render: ({ role }) => (isObject(role) ? role.name : '-'),
  },
  {
    accessor: 'etablissement',
    title: t('profil.affectations.columns.etablissement'),
    render: ({ etablissement }) => (isObject(etablissement) ? etablissement.name : '-'),
  },
  {
    accessor: 'status',
    title: t('profil.affectations.columns.status'),
    render: ({ status }) => <AffectationStatusBadge status={status} />,
  },
];
